module.exports = __webpack_public_path__ + "img/empty.644d10c6.png";